//@ts-check
import { openFailedDialog } from '@/common/components/kf-dialog';
import { hideLoading, showLoading } from '@/common/components/kf-loader';
import { STATUS_FAILURE_IDPASSWORD, STATUS_FAILURE_NO_OFFICE, STATUS_FAILURE_NO_OWNER, STATUS_FAILURE_NO_STAFF } from '@/common/constants';
import { errorHandler } from '../ajax';
import createBatchAction from '@/common/lib/create-batch-action';
import { createAction } from 'redux-actions';

const staffLoginErrorHandler = (err) => {
  switch (err.status) {
    case STATUS_FAILURE_NO_OFFICE:
    case STATUS_FAILURE_NO_STAFF:
    case STATUS_FAILURE_NO_OWNER:
      return openFailedDialog('現在利用できません。');
    case STATUS_FAILURE_IDPASSWORD:
      return openFailedDialog('パスワードが正しくありません。');
    default: 
      return errorHandler(err);
  }
};

export const initStaffLogin = createAction('@@staff-login/INIT_STAFF_LOGIN');
export const getOfficeRequest = createBatchAction('@@staff-login/GET_OFFICE_REQUEST', () => [showLoading()]);
export const getOfficeSuccess = createBatchAction('@@staff-login/GET_OFFICE_SUCCESS', (data) => [hideLoading(), initStaffLogin(data)]);
export const getOfficeFailure = createBatchAction('@@staff-login/GET_OFFICE_FAILURE', (err) => [
  hideLoading(), 
  err.status == STATUS_FAILURE_NO_OFFICE || err.status == STATUS_FAILURE_IDPASSWORD ? openFailedDialog('URLが無効です。') : errorHandler(err)
]);

export const staffLoginRequest = createBatchAction('@@staff-login/STAFF_LOGIN_REQUEST', () => [showLoading()]);
export const staffLoginSuccess = createBatchAction('@@staff-login/STAFF_LOGIN_SUCCESS', () => [hideLoading()]);
export const staffLoginFailure = createBatchAction('@@staff-login/STAFF_LOGIN_FAILURE', (err) => [
  hideLoading(), 
  staffLoginErrorHandler(err)
]);